/* eslint-disable react-hooks/rules-of-hooks */
import _ from 'lodash';

export const getStorageItem = (keyName) => {
  const value = localStorage.getItem(keyName);

  if (_.isNil(value)) {
    return value;
  }

  const parts = value.split('_');
  return parts[0];
};

export const removeStorageItem = (itemName) => {
  localStorage.removeItem(itemName);
};

export const saveStorageItem = (key, value) => {
  const processedValue = `${value.toString()}_${Date.now()}`;
  localStorage.setItem(key, processedValue);
};

export const getJsonFreeStorageItem = (itemKey) => {
  const item = localStorage.getItem(itemKey);
  return item ? JSON.parse(item) : '';
};
